/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type CreditCardRegistrationModalContractFragment = { isCreditCardAvailable: boolean };

export const CreditCardRegistrationModalContractFragmentDoc = gql`
    fragment CreditCardRegistrationModalContract on Contract {
  isCreditCardAvailable
}
    `;